<script setup lang="ts">
import TzDisplay from './TzDisplay.vue'
import UserPanel from './UserPanel.vue'
import CurrentTime from './CurrentTime.vue'

defineOptions({
  name: 'AdminDropdown',
})

</script>

<template>
  <div
    class="adm-dropdown"
  >
    <div class="adm-dropdown__time">
      <TzDisplay />
      <CurrentTime />
    </div>
    <UserPanel />
  </div>
</template>

<style scoped lang="scss" src="./AdminDropdown.scss" />
